/**
 * Promise that can be manually aborted via abort controllers, useful for canceling async operation
*/
export class AbortablePromise<T> extends Promise<T> {
  static create<T>(
    executor: (
      resolve: (value: T | PromiseLike<T>) => void,
      reject: (reason?: unknown) => void,
      signal: AbortSignal,
    ) => void,
  ): AbortablePromise<T> {
    return new AbortablePromise(executor);
  }

  private _abortReason?: string;
  private _abort: (reason?: string) => void;

  constructor(
    executor: (
      resolve: (value: T | PromiseLike<T>) => void,
      reject: (reason?: unknown) => void,
      signal: AbortSignal,
    ) => void,
  ) {
    const controller = new AbortController();

    super((resolve, reject) => {
      executor(resolve, reject, controller.signal);
    });

    this._abort = (reason) => {
      this._abortReason = reason || 'Aborted';
      controller.abort();
    };
  }

  get abortReason(): string | undefined {
    return this._abortReason;
  }

  abort(reason?: string): void {
    this._abort(reason);
  }
}
